<template>
    <el-form :model="merchantInvoiceSubject" :rules="subjectRules" :label-position="'left'" ref="merchantInvoiceSubject">
        <div class="simple-form">
            <div class="form-group center">
                <div class="form-label">
                    <label class="required">实体公司名称</label>
                </div>
                <div class="form-value">
                    <el-form-item label="" prop="realComCode">
                        <el-input class="width-2x" v-model="merchantInvoiceSubject.realComName" :disabled="true"></el-input>
                        <span class="swb-btn swb-btn-link" v-if="buyerRealComId == null" @click="setRealCom">实体公司</span>
                    </el-form-item>
                </div>
            </div>
            <div class="form-group center">
                <div class="form-label">
                    <label class="required">实体公司编码</label>
                </div>
                <div class="form-value">
                    <el-form-item label="" prop="realComCode">
                        <el-input class="width-2x" v-model="merchantInvoiceSubject.realComCode" :disabled="true"></el-input>
                    </el-form-item>
                </div>
            </div>
            <div class="form-group center">
                <div class="form-label">
                    <label class="required">发票类型</label>
                </div>
                <div class="form-value ">
                    <el-form-item prop="type">
                        <el-radio-group v-model="merchantInvoiceSubject.invoiceType" :disabled="invoiceType != null">
                            <el-radio v-for="invoiceType in invoiceTypeList" :label="invoiceType.value">{{ invoiceType.text }}</el-radio>
                        </el-radio-group>
                    </el-form-item>
                </div>
            </div>
            <div class="form-group center">
                <div class="form-label">
                    <label class="required">发票抬头</label>
                </div>
                <div class="form-value width-1-5x">
                    <el-form-item prop="invoiceTitle">
                        <el-input v-model="merchantInvoiceSubject.invoiceTitle"></el-input>
                    </el-form-item>
                </div>
            </div>
            <div class="form-group center">
                <div class="form-label">
                    <label class="required">纳税人识别号</label>
                </div>
                <div class="form-value width-1-5x">
                    <el-form-item prop="taxPayerNo">
                        <el-input v-model="merchantInvoiceSubject.taxPayerNo"></el-input>
                    </el-form-item>
                </div>
            </div>
            <div class="form-group center">
                <div class="form-label">
                    <label>开户银行</label>
                </div>
                <div class="form-value">
                    <el-form-item prop="bankName">
                        <el-input class="width-1-5x" v-model="merchantInvoiceSubject.bankName"></el-input>
                        <span class="swb-btn swb-btn-link" v-if="merchantInvoiceSubject.realComId != null" @click="selectBankAcc">选择</span>
                    </el-form-item>
                </div>
            </div>
            <div class="form-group center">
                <div class="form-label">
                    <label>银行账号</label>
                </div>
                <div class="form-value width-1-5x">
                    <el-form-item prop="acctNo">
                        <el-input v-model="merchantInvoiceSubject.acctNo"></el-input>
                    </el-form-item>
                </div>
            </div>
            <div class="form-group center">
                <div class="form-label">
                    <label>地址</label>
                </div>
                <div class="form-value width-1-5x">
                    <el-form-item prop="linkAddr">
                        <el-input v-model="merchantInvoiceSubject.linkAddr"></el-input>
                    </el-form-item>
                </div>
            </div>
            <div class="form-group center">
                <div class="form-label">
                    <label>联系人</label>
                </div>
                <div class="form-value width-1-5x">
                    <el-form-item prop="contactName">
                        <el-input v-model="merchantInvoiceSubject.contactName"></el-input>
                    </el-form-item>
                </div>
            </div>
            <div class="form-group center">
                <div class="form-label">
                    <label>联系电话</label>
                </div>
                <div class="form-value width-1-5x">
                    <el-form-item prop="contactTel">
                        <el-input v-model="merchantInvoiceSubject.contactTel"></el-input>
                    </el-form-item>
                </div>
            </div>
            <div class="form-group center">
                <div class="form-label">
                    <label>联系电子邮箱</label>
                </div>
                <div class="form-value width-1-5x">
                    <el-form-item prop="contactEmail">
                        <el-input v-model="merchantInvoiceSubject.contactEmail"></el-input>
                    </el-form-item>
                </div>
            </div>
        </div>
    </el-form>
</template>

<script>
    import {Utils} from '../../app.base'
    import {Vue, MsgBox} from '../../app.vues'
    import {selectRealComDlg} from '../comn/dialog'
    import {selectRealComBankAcctDialog} from '../merchtFinac/selectDlg'

    import merchtFinacApi from '../../api/merchtFinac'
    import merchtComnApi from '../../api/merchtComn'

    export default {
        name: 'swb-save-merchant-invoice-subject',
        desc: '保存发票主题信息',
        props: ['id', 'buyerRealComId', 'invoiceType'],
        data: function () {
            let validateInvoiceTitle = function (rule, value, callback) {
                if (Utils.isNoB(value)) {
                    callback(new Error('发票抬头不能为空'));
                } else {
                    callback();
                }
            };
            let validateContactTel = function (rule, value, callback) {
                if (!Utils.isNoB(value)) {
                    if (!Utils.isPhoneNo(value)) {
                        callback(new Error('请填写电话信息'));
                    } else {
                        callback();
                    }
                } else {
                    callback();
                }
            };
            let validateContactEmail = function (rule, value, callback) {
                if (!Utils.isNoB(value)) {
                    if (!Utils.isEmail(value)) {
                        callback(new Error('邮箱格式不正确'));
                    } else {
                        callback();
                    }
                } else {
                    callback();
                }
            };
            let validateNull = function (rule, value, callback) {
                if (Utils.isNoB(value)) {
                    callback(new Error('不可为空'));
                } else {
                    callback();
                }
            };
            return {
                merchantInvoiceSubject: {
                    disabled: true,
                    invoiceContentTag: null,
                    invoiceType: 1
                },
                invoiceTypeList: [],
                // 校验
                subjectRules: {
                    invoiceTitle: [{validator: validateInvoiceTitle, trigger: 'blur'}],
                    contactTel: [{validator: validateContactTel, trigger: 'blur'}],
                    contactEmail: [{validator: validateContactEmail, trigger: 'blur'}],
                    realComCode: [{validator: validateNull, trigger: 'blur'}],
                    taxPayerNo: [{validator: validateNull, trigger: 'blur'}]
                }
            }
        },
        created: function () {
            let invoiceTypeList = getEnumList("invoiceType");
            for (let i = 0; i < invoiceTypeList.length; i++) {
                let invoiceType = invoiceTypeList[i];
                if (invoiceType.value == 0) {
                    invoiceTypeList.splice(i, 1);
                    i--;
                }
            }
            this.invoiceTypeList = invoiceTypeList;
            if (!Utils.isNoB(this.id)) {
                this.getInvoiceSubject();
            }
            if (!Utils.isNoB(this.buyerRealComId)) {
                this.getRealComInfo();
            }
            if (!Utils.isNoB(this.invoiceType)) {
                let merchantInvoiceSubject = this.merchantInvoiceSubject || {};
                merchantInvoiceSubject.invoiceType = this.invoiceType;
                this.merchantInvoiceSubject = Utils.merge({}, merchantInvoiceSubject);
            }
        },
        methods: {
            getRealComInfo() {
                let self = this;
                let postData = {
                    id: this.buyerRealComId
                };
                merchtComnApi.getRealCom(postData, function (result) {
                    if (result.type == "info") {
                        let realComInfo = result.data || {};
                        self.setInviceBaseInfo(realComInfo);
                    } else {
                        MsgBox.warning(result.message);
                    }
                })
            },
            // 发票主体信息
            getInvoiceSubject: function () {
                let self = this;
                let postData = {};
                postData.id = self.id;
                //
                let msgBoxDlg = MsgBox.loading();
                merchtFinacApi.getMerchantInvoiceSubject(postData, function (result) {
                    msgBoxDlg.close();
                    if (result.type == 'info') {
                        let merchantInvoiceSubject = result.data || {};
                        self.merchantInvoiceSubject = Utils.merge({}, merchantInvoiceSubject);
                    } else {
                        MsgBox.warning(result.message);
                    }
                });
            },
            setRealCom() {
                let self = this;
                selectRealComDlg({}, function (realCom, theDlg) {
                    theDlg.close();
                    self.setInviceBaseInfo(realCom);
                });
            },
            setInviceBaseInfo: function (realCom) {
                let self = this;
                let merchantInvoiceSubject = self.merchantInvoiceSubject || {};
                merchantInvoiceSubject.realComId = realCom.id;
                merchantInvoiceSubject.realComCode = realCom.code;
                merchantInvoiceSubject.realComName = realCom.name;
                merchantInvoiceSubject.invoiceTitle = realCom.name;
                merchantInvoiceSubject.taxPayerNo = realCom.taxRegistNo;
                merchantInvoiceSubject.contactName = realCom.contactName;
                merchantInvoiceSubject.contactTel = realCom.contactTel;
                let regionName = Utils.isNoB(realCom.regionName) ? '' : realCom.regionName;
                let street = Utils.isNoB(realCom.street) ? '' : realCom.street;
                merchantInvoiceSubject.linkAddr = regionName + street;
                if (realCom.contactEmail == '无') {
                    merchantInvoiceSubject.contactEmail = null;
                } else {
                    merchantInvoiceSubject.contactEmail = realCom.contactEmail;
                }
                self.merchantInvoiceSubject = Utils.merge({}, merchantInvoiceSubject);
            },
            // 选择银行卡
            selectBankAcc: function () {
                let self = this;
                let merchantInvoiceSubject = self.merchantInvoiceSubject || {};
                if (Utils.isNoB(merchantInvoiceSubject.realComId)) {
                    MsgBox.warning("请选择实体公司");
                    return;
                }
                let params = {
                    realComId: merchantInvoiceSubject.realComId,
                    checkBox: false,
                    // usage: getEnumInfoWith('bankAcctUsage', 'name', 'Shroff').value
                };
                selectRealComBankAcctDialog(params, function (bankAcct) {
                    bankAcct = bankAcct || {};
                    if (!Utils.isNoB(bankAcct) && bankAcct.id > 0) {
                        merchantInvoiceSubject.bankName = bankAcct.bankName;
                        merchantInvoiceSubject.acctNo = bankAcct.cardNo;
                        merchantInvoiceSubject.bankCode = bankAcct.acctNo;
                        //
                        self.merchantInvoiceSubject = Utils.merge({}, merchantInvoiceSubject);
                    } else {
                        MsgBox.warning("请选择银行卡信息！");
                    }
                });
            },
            getDlgResult: function () {
                let self = this;
                let result = {};
                self.$refs['merchantInvoiceSubject'].validate(function (valid) {
                    if (valid) {
                        for (let i = 0; i < self.invoiceTypeList.length; i++) {
                            let invoiceTypeText = self.invoiceTypeList[i];
                            if (invoiceTypeText.value == self.merchantInvoiceSubject.invoiceType) {
                                self.merchantInvoiceSubject.invoiceTypeName = invoiceTypeText.text;
                            }
                        }
                        result.type = "info";
                        result.data = self.merchantInvoiceSubject;
                    } else {
                        result.type = "warn";
                        result.message = "校验失败";
                    }
                });
                return result;
            }
        }
    }
</script>



// WEBPACK FOOTER //
// src/compo/merchtFinac/SaveMerchantInvoiceSubject.vue